const LOCAL_STORAGE_PREFIX = 'bs:';

export const LOCAL_STORAGE = {
  CART: LOCAL_STORAGE_PREFIX + 'cart',
  USER: LOCAL_STORAGE_PREFIX + 'user',
};
